// Contenu d'aide contextuelle pour chaque page d'administration

export const helpContent = {
  dashboard: {
    title: "Aide - Tableau de bord",
    sections: [
      {
        title: "But de cette page",
        content: `Le tableau de bord vous offre une vue d'ensemble de l'activité de votre organisme. Vous pouvez consulter les statistiques des adhésions par année.`
      },
      {
        title: "Informations disponibles",
        content: `**Alerte doublons (si présente) :**
• Affiche le nombre de doublons détectés (email, NAPI, SIRET ou AMEXA identiques)
• Cliquez sur "Voir" pour examiner les doublons en détail

**Statistiques par année :**
• **Total adhérents** : Nombre total d'adhésions pour l'année sélectionnée
• **Actifs** : Adhésions validées et en cours
• **En cours** : Adhésions en attente de validation
• **En attente** : Adhésions en attente de paiement
• **Abandons** : Adhésions abandonnées

**Filtre par année :**
• Boutons pour sélectionner l'année à consulter
• L'année en cours est indiquée par "(en cours)"`
      },
      {
        title: "Actions possibles",
        content: `**Filtrer les statistiques :**
• Cliquez sur un bouton d'année pour afficher les statistiques de cette année
• Les statistiques se mettent à jour automatiquement

**Gérer les doublons :**
• Si des doublons sont détectés, cliquez sur "Voir" dans la bannière d'alerte
• Sélectionnez un doublon dans le menu déroulant pour comparer les utilisateurs côte à côte
• Examinez les informations de chaque utilisateur pour identifier le doublon à conserver`
      }
    ]
  },

  adhesions: {
    title: "Aide - Gestion des adhésions",
    sections: [
      {
        title: "",
        content: `Cette page vous permet de gérer toutes les adhésions de votre organisme : validation, suivi des paiements, modification des informations et gestion des documents.`
      },
      {
        title: "Informations disponibles",
        content: `**Pour chaque adhésion, vous pouvez consulter :**
• Informations personnelles de l'adhérent (nom, prénom, email, téléphone)
• Informations apicoles (NAPI, nombre de ruches, emplacements)
• Statut de l'adhésion (en attente, active, expirée)
• Statut du paiement (non demandé, demandé, payé)
• Documents fournis (justificatifs, attestations)
• Historique des modifications

**Filtres disponibles :**
• Par statut (actif, en attente, expiré)
• Par année d'adhésion
• Par statut de paiement
• Par recherche (nom, email, NAPI)`
      },
      {
        title: "Actions possibles",
        content: `**Validation des adhésions :**
• **Valider une adhésion** : Marquez une adhésion comme validée après vérification des informations
• **Refuser une adhésion** : Refusez une adhésion avec un motif (informations incorrectes, documents manquants)

**Gestion des paiements :**
• **Marquer comme payé** : Indiquez qu'un paiement a été reçu (chèque, virement, espèces)
• **Demander un paiement** : Envoyez une demande de paiement à l'adhérent
• **Voir les détails du paiement** : Consultez les informations de paiement Stripe

**Modification des informations :**
• **Modifier les informations** : Corrigez les informations de l'adhérent si nécessaire
• **Télécharger les documents** : Récupérez les justificatifs fournis par l'adhérent
• **Générer une attestation** : Créez une attestation d'adhésion officielle

**Actions groupées :**
• **Exporter en Excel** : Téléchargez la liste des adhésions au format Excel
• **Envoyer une communication** : Envoyez un email à tous les adhérents ou à une sélection`
      }
    ]
  },

  payments: {
    title: "Aide - Suivi des paiements",
    sections: [
      {
        title: "",
        content: `Cette page centralise tous les paiements de votre organisme : adhésions et services. Elle vous permet de suivre les paiements en attente et les paiements reçus.`
      },
      {
        title: "Informations disponibles",
        content: `**Onglet "Adhésions en attente" :**
• Liste des adhésions dont le paiement n'a pas été reçu
• Montant à régler
• Date d'inscription
• Statut du paiement (non demandé, demandé)

**Onglet "Services en attente" :**
• Liste des services (UNAF ou Miellerie) en attente de paiement
• Type de service
• Montant à régler
• Statut de la caution (pour la miellerie)

**Onglet "Paiements reçus" :**
• Liste des paiements effectués récemment
• Type de paiement (adhésion, service)
• Montant reçu
• Mode de paiement (en ligne, chèque, espèces)
• Date de paiement

**Statistiques :**
• Montant total en attente
• Nombre de paiements en attente
• Montant total reçu sur la période`
      },
      {
        title: "Actions possibles",
        content: `**Filtres :**
• **Par type de service** : Filtrez les paiements par type (Miellerie, Services UNAF)
• **Par année** : Sélectionnez l'année à consulter

**Actions sur les paiements :**
• **Voir le détail** : Cliquez sur l'icône œil pour accéder à la fiche complète de l'adhésion ou du service
• **Actualiser** : Rafraîchissez les données pour voir les derniers paiements
• **Exporter en Excel** : Téléchargez la liste des paiements reçus au format Excel (disponible sur l'onglet "Paiements reçus")`
      }
    ]
  },

  suiviAssurance: {
    title: "Aide - Suivi des services UNAF",
    sections: [
      {
        title: "",
        content: `Cette page est dédiée à la gestion des services d'assurance de l'UNAF pour les adhérents SAR. Elle permet de suivre les souscriptions, les modifications et les exports vers l'UNAF.`
      },
      {
        title: "Informations disponibles",
        content: `**Liste des services UNAF :**
• Informations de l'adhérent (nom, prénom, NAPI)
• Nombre de ruches assurées
• Nombre d'emplacements
• Montant de la cotisation
• Statut du service (en attente de paiement, en attente de validation, actif, expiré)
• Date de souscription
• Historique des modifications

**Statistiques :**
• Nombre total de services actifs
• Nombre de services en attente
• Montant total des cotisations UNAF
• Prochaine date d'export UNAF

**Calendrier des exports :**
• Dates d'export prévues pour l'année
• Historique des exports effectués
• Nombre de services inclus dans chaque export`
      },
      {
        title: "Actions possibles",
        content: `**Gestion des services :**
• **Valider un service** : Marquez un service comme validé après réception du paiement
• **Voir le détail** : Accédez à la fiche complète du service avec toutes les informations
• **Gérer les modifications** : Validez les demandes de modification (ajout/retrait de ruches)

**Exports UNAF :**
• **Générer un export** : Créez le fichier Excel à transmettre à l'UNAF (si vous avez la permission)
• **Télécharger un export** : Récupérez un fichier d'export précédent
• **Consulter l'historique** : Visualisez tous les exports effectués

**Filtres et recherche :**
• **Par statut** : Filtrez les services par statut (actif, en attente, expiré)
• **Par année** : Sélectionnez l'année à consulter
• **Recherche** : Recherchez un adhérent par nom, prénom ou NAPI

**Notifications :**
Vous recevez automatiquement un email lors de la génération d'un export UNAF.`
      }
    ]
  },

  communications: {
    title: "Aide - Communications",
    sections: [
      {
        title: "",
        content: `Cette page vous permet de créer et gérer des communications par email à destination de vos adhérents. Vous pouvez envoyer des informations, des convocations, des relances ou tout autre type de message.`
      },
      {
        title: "Informations disponibles",
        content: `**Liste des communications :**
• Titre de la communication
• Objet de l'email
• Type de communication (information, convocation, relance)
• Nombre de destinataires
• Statut (brouillon, programmée, envoyée)
• Date d'envoi ou de programmation
• Statistiques d'envoi (envoyés, erreurs)

**Détail d'une communication :**
• Contenu complet du message
• Liste des destinataires
• Pièces jointes
• Historique des modifications
• Statistiques détaillées (taux d'ouverture, clics)`
      },
      {
        title: "Actions possibles",
        content: `**Créer une communication :**
• **Nouvelle communication** : Cliquez sur "Nouvelle communication" pour créer un message
• **Rédiger le contenu** : Utilisez l'éditeur de texte enrichi pour rédiger votre message
• **Sélectionner les destinataires** : Adhérents (actifs / expirés par année), membres du CA (AMAIR, ADAR) ou du CS (SAR), et membres du bureau. Les doublons sont éliminés automatiquement.
• **Ajouter des pièces jointes** : Joignez des documents (PDF, Word, Excel, PowerPoint, images) — 10 Mo max par fichier, 5 fichiers, 20 Mo au total
• **Programmer l'envoi** : Envoyez immédiatement ou programmez à une date précise
• **Sauvegarder en brouillon** : Enregistrez pour envoyer plus tard

**Modifier une communication :**
• **Modifier** : Modifiez une communication tant qu'elle n'est pas envoyée
• **Supprimer** : Supprimez un brouillon ou une communication programmée

**Suivi des envois :**
• **Voir les statistiques** : Consultez le nombre d'emails envoyés, les erreurs, les ouvertures
• **Consulter l'historique** : Visualisez toutes les communications envoyées
• **Gérer les erreurs** : Identifiez les emails en erreur et corrigez les adresses

**Bonnes pratiques :**
• Utilisez un objet clair et concis
• Relisez avant d'envoyer
• Testez avec un envoi à vous-même d'abord`
      }
    ]
  },

  evenements: {
    title: "Aide - Événements",
    sections: [
      {
        title: "À quoi sert ce module",
        content: `Le module **Événements** permet de créer et gérer des événements **pour l’ensemble des organismes** auxquels vous avez accès en tant que pilote, pas seulement pour l’organisme actif sélectionné dans la barre latérale.

**Sur cette page vous pouvez :**
• Consulter les événements classés par onglets : **À venir**, **Brouillons**, **Passés**
• Créer un nouvel événement, puis le publier lorsqu’il est prêt
• Ouvrir la fiche d’un événement pour gérer les **dates et lieux**, les **documents**, les **volontaires** et les **référents**
• Filtrer par organisme ou rechercher par titre / description

**Affichage dans la liste :** pour chaque événement, une ligne **Organisateurs** indique les **organismes organisateurs** (badges) ; en dessous figurent les **référents**. Le titre de l’événement n’est plus accompagné de badges d’organismes.

**Rôles utiles à connaître :**
• **Pilotes / administrateurs** : création, modification, publication, gestion des candidatures volontaires et des documents selon les permissions
• **Référents** : personnes désignées sur un événement ; elles voient l’événement et peuvent aider à la coordination côté terrain`
      },
      {
        title: "Organismes concernés, organisateurs et référents",
        content: `**À la création ou à l’édition (pilotes)** vous cochez deux listes distinctes :

• **Organismes concernés** : public cible une fois l’événement **publié** (adhérents actifs de ces organismes le voient dans leur espace). Les **communications** créées depuis l’onglet **Partager** ciblent aussi les adhérents actifs de ces organismes.
• **Organismes organisateurs** : organismes **porteurs** de l’événement. Les **pilotes** de ces organismes (avec accès au module Événements) sont notamment destinataires de certaines **notifications** décrites ci‑dessous. Il peut y avoir **plusieurs** organismes organisateurs.

**Volontariat :** un adhérent peut se porter volontaire s’il a une adhésion active dans un organisme **concerné** ou **organisateur** de l’événement.

**Choix des référents :** la liste proposée regroupe les **adhérents actifs** (année en cours) **et** les **pilotes** habilités sur le module Événements, pour l’**union** des organismes cochés (concernés ∪ organisateurs). Elle se **met à jour** lorsque vous modifiez ces coches. Un pilote peut figurer dans la liste et être désigné référent.`
      },
      {
        title: "Notifications automatiques (emails)",
        content: `Certaines actions envoient des **emails** (adresses des comptes utilisateurs) :

**Candidatures volontaires — référents + pilotes organisateurs**
• **Nouvelle candidature** : les **référents** de l’événement **et** les **pilotes** des **organismes organisateurs** (avec permission d’accès au module Événements) reçoivent un message avec le candidat et un lien vers la fiche.
• **Annulation de candidature** ou **retrait** d’un volontaire : **mêmes destinataires** (référents + pilotes organisateurs).

**Nouveau document sur l’événement**
• Après l’ajout d’un fichier, un email signale qu’un document est consultable : **référents**, **pilotes des organismes organisateurs**, et — **uniquement si le document est partagé avec les volontaires** (audience « équipe et volontaires ») — les **volontaires déjà acceptés**.
• La personne qui vient d’**envoyer** le fichier **ne reçoit pas** cet email.

**Référent ajouté**
• Lorsqu’un **nouveau référent** est désigné sur l’événement, il reçoit un email d’information avec un lien d’accès.

**Indicateurs (pilotes)**
• **Badge** dans le menu latéral : nombre de **candidatures volontaires en attente** sur vos événements.
• **Bannière jaune** sur cette page : raccourcis vers les fiches concernées.`
      },
      {
        title: "Bonnes pratiques",
        content: `• Passez un événement en **publié** seulement lorsque les informations essentielles (dates, lieu, texte) sont finalisées.
• Vérifiez **organismes concernés** et **organisateurs** : ils pilotent à la fois la **visibilité** adhérents et les **notifications** côté pilotes.
• Vérifiez les **référents** avant publication : ils sont souvent parmi les premiers destinataires des alertes volontariat et documents.
• Utilisez l’onglet **Partager** sur la fiche événement (si disponible) pour préparer une **communication** vers les adhérents actifs des **organismes concernés**.`
      }
    ]
  },

  reunions: {
    title: "Aide - Suivi des réunions",
    sections: [
      {
        title: "",
        content: `Cette page vous permet de gérer les réunions de votre organisme : assemblées générales, conseils d'administration, bureaux, etc. Vous pouvez créer des réunions, gérer les participants et rédiger les comptes-rendus.`
      },
      {
        title: "Informations disponibles",
        content: `**Liste des réunions :**
• Titre de la réunion
• Type de réunion (assemblée générale, conseil d'administration, bureau)
• Date et heure
• Lieu (physique ou visioconférence)
• Nombre de participants
• Statut (à venir, terminée)
• Présence du compte-rendu

**Détail d'une réunion :**
• Ordre du jour
• Liste des participants (présents, absents, excusés)
• Documents joints (convocation, ordre du jour, présentations)
• Compte-rendu
• Décisions prises
• Actions à suivre`
      },
      {
        title: "Actions possibles",
        content: `**Créer une réunion :**
• **Nouvelle réunion** : Cliquez sur "Nouvelle réunion" pour créer une réunion
• **Définir les informations** : Titre, type, date, heure, lieu
• **Rédiger l'ordre du jour** : Listez les points à aborder
• **Inviter les participants** : Sélectionnez les membres à inviter
• **Joindre des documents** : Ajoutez la convocation, des présentations, etc.

**Gérer les participants :**
• **Ajouter des participants** : Invitez des membres du conseil ou du bureau
• **Marquer les présences** : Indiquez qui était présent, absent ou excusé
• **Envoyer des invitations** : Envoyez automatiquement les convocations par email

**Rédiger le compte-rendu :**
• **Ajouter un compte-rendu** : Rédigez le compte-rendu après la réunion
• **Lister les décisions** : Notez les décisions prises
• **Définir les actions** : Listez les actions à suivre avec les responsables
• **Joindre des documents** : Ajoutez le PV signé, des annexes, etc.

**Consulter l'historique :**
• **Filtrer par type** : Affichez uniquement les AG, les conseils ou les bureaux
• **Filtrer par année** : Consultez les réunions d'une année spécifique
• **Rechercher** : Recherchez une réunion par mot-clé`
      }
    ]
  },

  compositionConseil: {
    title: "Aide - Composition du conseil",
    sections: [
      {
        title: "",
        content: `Cette page vous permet de gérer la composition du conseil d'administration et du bureau de votre organisme. Vous pouvez ajouter, modifier ou retirer des membres, et générer un PDF officiel de la composition.`
      },
      {
        title: "Informations disponibles",
        content: `**Composition du conseil :**
• Liste des membres du conseil d'administration
• Fonction de chaque membre (président, trésorier, secrétaire, administrateur)
• Fraction représentée (pour les organismes avec fractions)
• Période de mandat
• Date d'élection
• Statut (actif, démissionnaire)

**Composition du bureau :**
• Président
• Vice-président(s)
• Trésorier
• Secrétaire
• Autres membres du bureau

**Historique :**
• Anciennes compositions
• Modifications effectuées
• Dates des changements`
      },
      {
        title: "Actions possibles",
        content: `**Modifier la composition :**
• **Modifier le conseil** : Cliquez sur "Modifier la composition" pour ajouter, modifier ou retirer des membres
• **Ajouter un membre** : Sélectionnez un adhérent et attribuez-lui une fonction
• **Modifier une fonction** : Changez la fonction d'un membre existant
• **Retirer un membre** : Marquez un membre comme démissionnaire ou retirez-le

**Modifier le bureau :**
• **Modifier le bureau** : Cliquez sur "Modifier le bureau" pour gérer les membres du bureau
• **Attribuer les fonctions** : Désignez le président, le trésorier, le secrétaire, etc.

**Générer des documents :**
• **Générer le PDF** : Créez un document officiel de la composition du conseil et du bureau
• **Télécharger le PDF** : Récupérez le PDF pour l'imprimer ou le diffuser
• **Joindre aux convocations** : Utilisez le PDF pour les convocations d'AG

**Gestion des périodes :**
• Les périodes de mandat sont calculées automatiquement selon la fraction et la date d'élection
• Vous pouvez consulter l'historique des compositions précédentes

**Mise à jour :**
Pensez à générer un nouveau PDF après chaque modification de la composition.`
      }
    ]
  },

  users: {
    title: "Aide - Utilisateurs",
    sections: [
      {
        title: "But de cette page",
        content: `Cette page affiche la liste de tous les utilisateurs ayant au moins une adhésion à votre organisme. Elle vous permet de consulter leurs informations, leurs adhésions et de modifier certaines données si nécessaire.`
      },
      {
        title: "Informations disponibles",
        content: `**Pour chaque utilisateur, vous pouvez consulter :**
• Nom et prénom
• Email et téléphone
• Numéro NAPI (Numéro d'Apiculteur)
• Numéro AMEXA (sécurité sociale agricole)
• Liste de toutes les adhésions (avec organisme, année et statut)
• Nombre total d'adhésions

**Statuts des adhésions affichés :**
• ✓ **Actif** : Adhésion validée et en cours
• ⏳ **En attente** : Adhésion en attente de validation
• 💳 **Paiement demandé** : En attente de paiement

**Filtres disponibles :**
• **Recherche** : Recherchez par nom, prénom ou email
• **Par organisme** : Filtrez les utilisateurs ayant une adhésion à un organisme spécifique (visible uniquement en mode Super Admin)`
      },
      {
        title: "Actions possibles",
        content: `**Rechercher un utilisateur :**
• Utilisez la barre de recherche pour trouver rapidement un utilisateur
• La recherche fonctionne sur le nom, prénom et email

**Consulter les adhésions :**
• **Voir les adhésions** : Cliquez sur le bouton "Voir adhésions" pour afficher la liste détaillée de toutes les adhésions d'un utilisateur
• La popup affiche chaque adhésion avec son organisme, année, statut et montant

**Modifier les informations :**
• **Modifier** : Cliquez sur l'icône crayon pour modifier les informations d'un utilisateur (si vous avez la permission)
• Vous pouvez modifier :
- Nom et prénom
- Email
- Téléphone
- Adresse complète
- Numéro NAPI
- Numéro AMEXA

**Sauvegarder les modifications :**
• Après modification, cliquez sur "Enregistrer" pour sauvegarder les changements
• Les modifications sont appliquées immédiatement

**Permissions requises :**
• **Consulter** : Permission "Accès aux utilisateurs"
• **Modifier** : Permission "Modifier les utilisateurs"

**Compteur de résultats :**
Le nombre d'utilisateurs affichés est indiqué en haut à droite et se met à jour automatiquement selon vos filtres et recherches.`
      }
    ]
  },

  parametresAdhesion: {
    title: "Aide - Paramètres d'adhésion",
    sections: [
      {
        title: "",
        content: `Cette page vous permet de configurer les paramètres liés aux adhésions de votre organisme : tarifs, options, services disponibles, etc. Ces paramètres sont utilisés lors de la création d'une nouvelle adhésion.`
      },
      {
        title: "Informations disponibles",
        content: `**Tarifs :**
• Cotisation de base
• Tarifs par tranche de ruches
• Tarifs des services (UNAF, Miellerie)
• Montant de la caution (Miellerie)

**Options disponibles :**
• Services proposés (UNAF, Miellerie, autres)
• Documents requis pour l'adhésion
• Champs obligatoires du formulaire

**Configuration :**
• Année en cours
• Dates limites pour les adhésions
• Messages personnalisés`
      },
      {
        title: "Actions possibles",
        content: `**Modifier les tarifs :**
• **Cotisation de base** : Définissez le montant de la cotisation annuelle
• **Tarifs par tranche** : Configurez les tarifs selon le nombre de ruches
• **Tarifs des services** : Définissez les montants pour les services UNAF ou Miellerie

**Configurer les services :**
• **Activer/désactiver** : Activez ou désactivez les services disponibles
• **Définir les options** : Configurez les options de chaque service

**Personnaliser les messages :**
• **Messages d'information** : Personnalisez les messages affichés lors de l'adhésion
• **Emails automatiques** : Configurez les emails envoyés automatiquement

**Sauvegarder :**
• **Enregistrer les modifications** : Cliquez sur "Enregistrer" pour appliquer les changements
• Les modifications sont appliquées immédiatement pour les nouvelles adhésions`
      }
    ]
  },

  miellerieSolde: {
    title: 'Aide - Mon solde miellerie',
    sections: [
      {
        title: 'But de cette page',
        content: `Cette page centralise votre **compte miellerie AMAIR** : solde actuel, dette éventuelle, historique des mouvements et régularisation en ligne.

**Solde positif ou nul** : vous êtes à jour (un crédit positif peut exister si un montant vous a été restitué).

**Solde négatif** : vous avez une dette à régulariser, enregistrée au fil de vos usages à la miellerie collective.`,
      },
      {
        title: 'Comment le solde évolue',
        content: `Chaque mouvement apparaît dans l'historique (10 lignes par page) :

• **Réservation** : dette enregistrée après un passage à la miellerie (montant négatif sur le solde)
• **Paiement** : règlement reçu (sur place ou en ligne) — montant positif
• **Annulation** : crédit si une réservation est annulée
• **Ajustement** : correction manuelle par un responsable

Le libellé de chaque ligne précise la **prestation** concernée (dépôt, extraction, etc.) et la **date** du créneau.`,
      },
      {
        title: 'Régulariser ma dette',
        content: `Si vous avez une dette, le bouton **Régulariser ma dette** ouvre une fenêtre de paiement :

• Saisissez le montant (totalité ou partie de la dette)
• **Paiement sécurisé par carte** via Stripe
• Vous pouvez aussi régler en **espèces ou chèque** auprès du responsable de permanence (enregistré par lui lors de la validation de votre passage)

Après un paiement en ligne réussi, votre solde et l'historique sont mis à jour automatiquement.`,
      },
      {
        title: 'Rappels après les miellées',
        content: `La plateforme prévoit des **rappels par e-mail** aux adhérents endettés aux dates suivantes :

• **30 avril** (miellée de printemps)
• **30 juillet** (miellée d'été)
• **31 octobre** (miellée d'automne)
• **20 décembre** (miellée d'hiver)

Ces rappels ne partent **que si vous avez une dette** à cette date. Un seul rappel par période et par année. Ils rappellent le montant dû et le lien pour régulariser en ligne.

**À noter :** l'envoi automatique dépend du serveur de l'association (tâche planifiée quotidienne). Si vous pensez ne pas avoir reçu de rappel alors que vous avez une dette, contactez l'AMAIR.`,
      },
      {
        title: 'Blocage en cas de dette',
        content: `Une dette **ne bloque pas immédiatement** l'accès à la miellerie.

**En pratique :**
• Tant que votre compte n'est pas marqué « accès bloqué », vous pouvez **consulter** le calendrier et **réserver** un créneau
• Le blocage concerne surtout les **nouvelles réservations** (pas la consultation de cette page)
• Il peut être activé automatiquement pour les dettes **persistantes** après le cycle de rappels de fin d'année (logique liée au rappel du **20 décembre** et à un délai de régularisation)
• Dès que la dette est **soldée** (paiement en ligne ou enregistrement par le responsable), le blocage est **levé**

Si un bandeau rouge « Accès bloqué depuis le… » s'affiche sur cette page, régularisez votre dette pour retrouver la possibilité de réserver.`,
      },
    ],
  },
};
